import React, { memo } from 'react'
import { makeStyles, createStyles } from '@mui/styles'
import { Theme } from '@mui/material'

import { IBankRatesProps } from './typings'
import NormalInterestRate from './NormalInterestRate'
import SpecialInterestRateContainer from './SpecialInterestRateContainer'
import { ISpecialInterestRate } from '../special-interest-rate/typings'

const useStyles = makeStyles<Theme, ISpecialInterestRate>((theme: Theme) =>
  createStyles({
    rateTextContent: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: 0,
      height: '100%',
      margin: 10,
      minWidth: 100,
      [theme.breakpoints.down('md')]: {
        order: ({ isSpecial, order }) => (isSpecial ? '-1' : order || ''),
        width: 'calc(100% - 10px);',
        minWidth: 'calc(100% - 10px);',
        marginLeft: 20,
        marginTop: 10,
      },
    },
  }),
)

const BankRate = (bankRateProps: IBankRatesProps) => {
  const { specialInterestRate } = bankRateProps
  const { rateTextContent } = useStyles(
    specialInterestRate || { isSpecial: false },
  )

  return (
    <div className={rateTextContent}>
      {!specialInterestRate?.isSpecial ? (
        <NormalInterestRate {...bankRateProps} />
      ) : (
        <SpecialInterestRateContainer {...bankRateProps} />
      )}
    </div>
  )
}

export default memo(BankRate)
